import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const LABELS = { montagem: "Montagem", desmontagem: "Desmontagem", revisao_30d: "Revisão (30 dias)", assistencia: "Assistência", mostruario: "Mostruário" };

export default function ReferenciasValores() {
  const [itens, setItens] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/referencias-valores").then(r => setItens(r.data.itens)); }, []);
  const salvar = async () => {
    setBusy(true);
    try {
      await api.put("/admin/referencias-valores", { itens });
      toast.success("Referências da rede atualizadas");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="p-8 max-w-2xl" data-testid="referencias-page">
      <div className="label-cap">ADM Master</div>
      <h1 className="font-heading font-extrabold text-3xl tracking-tighter mt-1">Referência Mínima Recomendada</h1>
      <p className="text-sm text-muted-foreground mt-2">
        Valores de referência da rede MontaJá. Empresas que cadastrarem abaixo recebem apenas um aviso
        (não bloqueia e não gera alerta operacional) — registrado internamente para inteligência.
      </p>
      <div className="border border-border bg-white p-5 mt-6 space-y-3">
        {Object.entries(itens).map(([k, v]) => (
          <div key={k} className="grid grid-cols-3 gap-3 items-center text-sm">
            <span className="font-semibold">{LABELS[k] || k.replace(/_/g, " ")}</span>
            <select value={v.modo} onChange={e => setItens(p => ({ ...p, [k]: { ...v, modo: e.target.value } }))}
              className="border border-border bg-white p-2 text-sm" data-testid={`ref-modo-${k}`}>
              <option value="percentual">Percentual (%)</option>
              <option value="fixo">Valor fixo (R$)</option>
            </select>
            <Input type="number" step="0.5" value={v.valor}
              onChange={e => setItens(p => ({ ...p, [k]: { ...v, valor: Number(e.target.value) } }))}
              data-testid={`ref-valor-${k}`} />
          </div>
        ))}
        <Button onClick={salvar} disabled={busy} className="btn-sharp brand-bg text-white w-full mt-2" data-testid="ref-salvar">
          Salvar referências
        </Button>
      </div>
    </div>
  );
}
